var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 39 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.583 12.792H6.541l9.042-9.042a1.7 1.7 0 0 0 .521-1.214 1.7 1.7 0 0 0-.5-1.223 1.7 1.7 0 0 0-1.223-.5 1.7 1.7 0 0 0-.659.139c-.209.09-.397.22-.555.383L1.209 13.292a1.71 1.71 0 0 0 0 2.416l11.958 11.958a1.71 1.71 0 0 0 2.395-.021 1.71 1.71 0 0 0 .021-2.395l-9.042-9.042h30.043a1.71 1.71 0 0 0 1.708-1.708 1.71 1.71 0 0 0-1.708-1.708z"
  })));
};
export default SvgArrow;